<template>
  <div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8"></base-header>
    <div class="container-fluid mt--9">
      <div class="row">
        <div class="col-xl-12 mb-5 mb-xl-0">
          <div class="card">
            <div class="card-header d-xl-flex justify-content-between">
              <div>
                <h3 class="mb-0">Ordenes de Compra</h3>
                <h4 v-if="paramsData.type === 'ShipmentID'" class="m-0 mt-1">
                  <span class="font-weight-normal">Shipment ID: </span> 
                  <b>{{ paramsData.value }}</b>
                </h4>
                <h4 v-else-if="paramsData.type === 'CardCode'" class="m-0 mt-1"> 
                  <span class="font-weight-normal">Proveedor: </span>
                  <b>{{ paramsData.value }} - {{ paramsData.name }}</b>
                </h4>
              </div>
              <div>
                <base-button
                  v-if="selected.length" 
                  @click="showModalEditMultiple = true"
                  icon="fa fa-pen"
                  size="sm"  
                >
                  Modificar     
                  <span v-if="selected.length > 0">({{ selected.length }})</span>
                </base-button>

              <base-button 
                v-if="paramsData.type === 'ShipmentID' && selected.length" 
                @click="showCreateST = true"
                size="sm"
              >
                Crear ST 
                <span v-if="selected.length > 0">({{ selected.length }})</span>
              </base-button>
              <base-button 
                v-if="modified.length > 0"
                @click="saveChanges"
                size="sm"
                icon="fa fa-check"
                type="primary"
              >
                Guardar cambios
              </base-button>

              </div>
            </div>
  
            <div class="card-body py-3 justify-content-between d-flex ">
              <h5 class="m-0">
                Selecciona las líneas que desees modificar:
              </h5>
              <h5 class="m-0">
                {{ selected.length }} línea(s) seleccionada(s)
              </h5>
            </div>
            <ag-grid-vue
              ref="agST" 
              style="height: 70vh;" 
              class="ag-theme-alpine mb-5" 
              v-bind="agST"
              @gridReady="onGridReady" 
              @selectionChanged="onSelectionChanged"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para cambiar el valor de un campo a multiples líneas -->
    <b-modal v-model="showModalEditMultiple" hide-footer hide-header  size="md" centered>
      <SetFields 
        v-if="showModalEditMultiple"
        :seguimientoOptions="seguimientoOptions"
        @setFields="setChanges" 
        @close="showModalEditMultiple = false"
      />
    </b-modal>

    <!-- Modal para crear ST -->
    <b-modal v-model="showCreateST" hide-footer hide-header size="xl" centered>
      <NewST
        v-if="showCreateST"
        :selected="selected"
        @success="getData"
        @close="showCreateST = false"
      />
    </b-modal>

    <Overlay v-if="saving">
      <base-loader text="Guardando Cambios. Por favor espere, esta operación podría demorar." class="mx-4 flex-grow-1"/>
    </Overlay>
  </div>
</template>
<style></style>

<script>
/* eslint-disable vue/no-unused-components */

import Multiselect from "vue-multiselect";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import axios from "axios";
import BaseLoader from "@/components/BaseLoader.vue";
import { AgGridVue } from "ag-grid-vue";
import { AG_GRID_LOCALE_ES } from "@ag-grid-community/locale";
import AgGrid from "@/mixins/AgGrid";
import FilterDate from "@/components/AgGrid/Filters/FilterDate.vue";
import Formats from "@/mixins/Formats.js";
import SetFields from "./SetFields.vue";
import NewST from "./NewST.vue";
import Overlay from "@/components/Overlay.vue";
export default {
  mixins: [AgGrid, Formats],
  components: {
    BaseLoader,
    Multiselect,
    flatPicker,
    AgGridVue,
    agDateInput: FilterDate,
    SetFields,
    NewST,
    Overlay,
  },
  data() {
    return {
      selected: [],
      shipmentID: null,
      modified: [],
      saving: false,
      seguimientoOptions: [],
      showModalEditMultiple: false,
      showCreateST: false,
      paramsData: {
        type: null,
        value: null,
        name: null,
        endpoint: null,
      },
      agST: {
        rowData: null,
        columnDefs: [
          {
            colId: "checkbox",
            checkboxSelection: true,
            headerCheckboxSelection: true,
            width: 70,
            suppressHeaderMenuButton: true,
            sortable: false,
            resizable: false,
            filter: false,
          },
          {
            field: "PurchaseOrders/DocumentLines.LineNum",
            headerName: "LineNum",
            filter: "agTextColumnFilter",
            width: 100,
          },
          {
            field: "PurchaseOrders.DocNum",
            headerName: "DocNum",
            filter: "agNumberColumnFilter",
            width: 120,
            sort: "desc",
          },
          {
            field: "PurchaseOrders/DocumentLines.ItemCode",
            headerName: "Código",
            filter: "agTextColumnFilter",
            width: 160,
          },
          {
            field: "PurchaseOrders/DocumentLines.ItemDescription",
            headerName: "Artículo",
            filter: "agTextColumnFilter",
            width: 300,
          },
          {
            field: "PurchaseOrders/DocumentLines.Quantity",
            headerName: "Cantidad",
            filter: "agNumberColumnFilter",
            width: 120,
            type: "rightAligned",
            valueFormatter: ({ value }) => this.numberFormat(value),
          },
          {
            field: "PurchaseOrders/DocumentLines.UoMCode",
            headerName: "Unidad",
            filter: "agTextColumnFilter",
            width: 120,
          },
          {
            field: "PurchaseOrders/DocumentLines.WarehouseCode",
            headerName: "Almacén",
            filter: "agSetColumnFilter",
            width: 120,
          },
          {
            field: "PurchaseOrders/DocumentLines.U_Issue_ValidatedQty",
            headerName: "# ST",
            filter: "agTextColumnFilter",
            width: 120,
          },
          {
            field: "PurchaseOrders/DocumentLines.UnitPrice",
            headerName: "Precio Unitario",
            filter: "agNumberColumnFilter",
            width: 120,
            type: "rightAligned",
            valueFormatter: ({ value, data }) =>
              this.currencyFormat(value, data['PurchaseOrders'].DocCurrency),
          },
          {
            field: "PurchaseOrders/DocumentLines.TaxCode",
            headerName: "TaxCode",
            filter: "agTextColumnFilter",
            width: 100,
          },
          {
            headerName: "Total",
            filter: "agNumberColumnFilter",
            width: 120,
            type: "rightAligned",
            valueGetter: ({data}) => {
              const { RowTotalSC, RowTotalFC } = data['PurchaseOrders/DocumentLines'];
              return data['PurchaseOrders'].DocCurrency === "MXP" ? RowTotalSC : RowTotalFC;
            },
            valueFormatter: ({ value, data }) => 
              this.currencyFormat(value, data['PurchaseOrders'].DocCurrency),
          },
          {
            field: "PurchaseOrders/DocumentLines.ShipDate",
            headerName: "Fecha de llegada",
            filter: "agDateColumnFilter",
            width: 120,
          },
          {
            field: "PurchaseOrders/DocumentLines.U_Issue_ValidatedComment",
            headerName: "CEDIS Destino",
            filter: "agTextColumnFilter",
            width: 120,
          },
          {
            field: "PurchaseOrders/DocumentLines.U_TS_Marca",
            headerName: "Shipment ID",
            filter: "agTextColumnFilter",
            width: 140,
          },
          {
            field: "PurchaseOrders/DocumentLines.U_TrackingInfoPO",
            headerName: "Info de rastreo",
            filter: "agTextColumnFilter",
            width: 170,
          },
          {
            field: "PurchaseOrders/DocumentLines.U_FollowUp",
            headerName: "Seguimiento",
            filter: "agTextColumnFilter",
            width: 120,
            valueFormatter: this.followUpFormat
          },
          {
            field: "PurchaseOrders/DocumentLines.U_FechaConf",
            headerName: "Fecha conf",
            filter: "agTextColumnFilter",
            width: 120,
          },
          {
            field: "PurchaseOrders/DocumentLines.FreeText",
            headerName: "Texto Libre",
            filter: "agTextColumnFilter",
            width: 130,
          },
          {
            field: "PurchaseOrders/DocumentLines.U_PedimentNum",
            headerName: "Pedimento",
            filter: "agTextColumnFilter",
            width: 120,
          },
          {
            field: "PurchaseOrders/DocumentLines.U_Real_Load_Date",
            headerName: "Fecha Real",
            filter: "agTextColumnFilter",
            width: 120,
          },
        ],
        defaultColDef: {
          menuTabs: ["filterMenuTab"],
          sortable: true,
          resizable: true,
          cellDataType: false,
          filter: true,
          enableCellChangeFlash:true,

        },
        rowSelection: "multiple",
        pagination: true,
        paginationPageSize: 1000,
        paginationPageSizeSelector: [100, 500, 1000, 2000],
        loadingOverlayComponent: "BaseLoader",
        suppressCellFocus: true,
        enableCellTextSelection: true,
        localeText: AG_GRID_LOCALE_ES,
        alwaysShowVerticalScroll: true,
        rowMultiSelectWithClick: true,
      },

      MeasureUnitOptionsAll: null,
    };
  },
  created() {
    axios.get(`/api/items/units_measurement`)
    .then((response) => {
      this.MeasureUnitOptionsAll = response.data.value;
    });
  
    axios.get(`/api/user_fields/FollowUp`)
    .then((response) => {
      this.seguimientoOptions = response.data.value[0].ValidValuesMD;
      if(this.$refs.agST){
        this.$refs.agST.api.refreshCells({ columns: ['PurchaseOrders/DocumentLines.U_FollowUp'] });
      }
    });
  },
  beforeDestroy(){
    window.removeEventListener('beforeunload', this.preventExit);
  },
  mounted() {
    window.addEventListener('beforeunload', this.preventExit);

    if (this.$route.query.CardCode) {
      this.paramsData.type = "CardCode";
      this.paramsData.value = this.$route.query.CardCode;
      this.paramsData.endpoint = `/api/purchase_orders_lines/by_cardcode`;
    } else if(this.$route.query.ShipmentID) {
      this.paramsData.type = "ShipmentID";
      this.paramsData.value = this.$route.query.ShipmentID;
      this.paramsData.endpoint = `/api/purchase_orders_lines/by_shipment_id`;
      this.shipmentID = this.$route.query.ShipmentID;
    }
    this.getData();
  },
  methods: {
    getData(){
      this.modified = [];
      const {type, value, endpoint} = this.paramsData;
      const json = {
        po_select: "DocNum, DocRate, CardName, DocEntry, CardCode, DocDueDate, DocCurrency",
        lines_select: "ShipDate, ItemCode, ItemDescription, U_Issue_ValidatedComment,RemainingOpenQuantity, Quantity, UoMCode, MeasureUnit, WarehouseCode, UnitPrice, TaxCode, RowTotalSC, RowTotalFC, U_Issue_ValidatedComment, U_TS_Marca, U_TrackingInfoPO, U_FollowUp, U_FechaConf, FreeText, U_PedimentNum, U_Issue_ValidatedQty, LineNum, U_Real_Load_Date, LineStatus, U_ProveedorDIOT",
        [type]: value,
      };
      axios.post(endpoint, json).then(res => {
        this.agST.rowData = res.data.value;
        this.paramsData.name = res.data.value.length && res.data.value[0].PurchaseOrders.CardName;
      });
    },
    onGridReady() {
    },
    onSelectionChanged({ api }) {
      this.selected = api.getSelectedRows();
    },
    followUpFormat({value}){
      const followUp = this.seguimientoOptions.find((item) => item.Value === value);
      return followUp ? followUp.Description : value;
    },
    setChanges(field, value) {
      const api = this.$refs.agST.api;
      api.getSelectedNodes().forEach((node) => {
        const { LineNum } = node.data["PurchaseOrders/DocumentLines"];
        const { DocNum } = node.data["PurchaseOrders"];

        node.setDataValue(`PurchaseOrders/DocumentLines.${field}`, value);
        
        if(!this.modified.find(x => x.DocNum === DocNum && x.LineNum === LineNum)){
          this.modified.push({
            DocNum: DocNum,
            LineNum: LineNum,
          });
        }
      });
      this.showModalEditMultiple = false;
    },
    async getDocLines(docNums){ // Get all DocumentLines of modified DocNums only
      const resGet = [];
      const errGet = [];

      for (const docNum of docNums) { 
        try {
          console.log("GET", docNum);
          const res = await axios.get(`/api/purchase_orders/dn/${docNum}`);
          if(res.data.value && res.data.value.length > 0){

            const docLines = res.data.value[0].DocumentLines.filter(x => x.LineStatus === "bost_Open");
            const modifiedLinesByDocNum = this.modified.filter(x => x.DocNum === docNum);

            modifiedLinesByDocNum.forEach(line => {
              const index = docLines.findIndex(x => x.LineNum === line.LineNum);
              const {rowData} = this.agST;
              const indexRD = rowData.findIndex(x => {
                return (
                  x["PurchaseOrders"].DocNum === line.DocNum && 
                  x["PurchaseOrders/DocumentLines"].LineNum === line.LineNum
                );
              });
              const {
                FreeText, Quantity, ShipDate, TaxCode, U_FechaConf, U_FollowUp, U_Issue_ValidatedQty, U_PedimentNum, U_TS_Marca, U_TrackingInfoPO, UnitPrice, WarehouseCode, U_Real_Load_Date, U_Issue_ValidatedComment
              } = rowData[indexRD]["PurchaseOrders/DocumentLines"];

              docLines[index].FreeText = FreeText;
              docLines[index].Quantity = Quantity;
              docLines[index].ShipDate = ShipDate;
              docLines[index].TaxCode = TaxCode;
              docLines[index].U_FechaConf = U_FechaConf;
              docLines[index].U_FollowUp = U_FollowUp;
              docLines[index].U_Issue_ValidatedQty = U_Issue_ValidatedQty;
              docLines[index].U_PedimentNum = U_PedimentNum;
              docLines[index].U_TS_Marca = U_TS_Marca;
              docLines[index].U_TrackingInfoPO = U_TrackingInfoPO;
              docLines[index].UnitPrice = UnitPrice;
              docLines[index].WarehouseCode = WarehouseCode;
              docLines[index].U_Real_Load_Date = U_Real_Load_Date;
              docLines[index].U_Issue_ValidatedComment = U_Issue_ValidatedComment;
            })

            const json = {
              DocumentLines: {
                DocumentLines: docLines,
              },
            };
            // console.log("JSON", json);
            // Add edited lines to json to patchPurchaseOrders()
            resGet.push({ docEntry: res.data.value[0].DocEntry, json, docNum: docNum }); 
          }
          else {
            errGet.push(res.data);
            console.error("Error. DocNum:", docNum, res.data);
          }
        } catch (e) {
          errGet.push(e);
          console.error("Error. DocNum:", docNum, e);

        }
      }

      return {resGet, errGet};
    },
    async patchPurchaseOrders(requests){ // Patch DocumentLines of modified DocNums only
      const resPatch= [];
      const errPatch = [];

      for (const {docEntry, json, docNum} of requests) { 
        try {
          console.log("PATCH", "DocEntry:", docEntry, "DocNum:", docNum, json);
          const res = await axios.patch(`/api/purchase_orders/${docEntry}`, json);
          if(res.data.result && res.data.result === "OK"){
            resPatch.push(res.data.res);
          }
          else {
            errPatch.push(res.data)
            console.error("Error. DocEntry:", docEntry, res.data);
          }
        } catch (error) {
          errPatch.push(error);
          console.error("Error. DocEntry:", docEntry, error);
        }
      }

      return {resPatch, errPatch};
    },
    saveChanges(){
      this.$swal({
        title: `¿Deseas guardar los cambios?`,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCancelButton: true,
        icon: 'question',
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.saving = true;
          const uniqueDocNums = [...new Set(this.modified.map(x => x.DocNum))];
          this.getDocLines(uniqueDocNums).then(({resGet, errGet}) => {
            this.patchPurchaseOrders(resGet).then(({errPatch}) => {
              if(!errPatch.length && !errGet.length){
                this.$swal("Cambios guardados", "", "success");
                this.getData();
              } else {
                if(errGet.length) console.error("Get errors", errGet);
                if(errPatch.length) console.error("Patch errors", errPatch);
                
                const msg = [...errGet, ...errPatch].find(e => e.sl_err)
                this.$swal(
                  `Hubo un error al guardar los cambios`, 
                  (msg && msg.sl_err.error.message.value), 
                  "warning"
                );
              }
            })
            .finally(() => {
              this.modified = [];
              this.saving = false;
            });
          });
        }
      });
    },
    preventExit(event) {
      if(this.saving){
        event.preventDefault();
        event.returnValue = "Guardando cambios. ¿Estás seguro que deseas salir de la página? Si sales, podrías afectar el proceso de guardado";
      }
    },
  },
  beforeRouteLeave(to, from, next){
    if(this.saving){
      this.$swal({
        title: "Guardando cambios",
        text: "¿Estás seguro que deseas salir de la página? Si sales, podrías afectar el proceso de guardado",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Salir de todos modos",
        cancelButtonText: "Permanecer en la página",
      })
      .then((result) => {
        if (result.isConfirmed) {
          next();
        }
      });
    } else {
      next();
    }
  }

};
</script>
